export const REQUEST_AIRPORTS = 'REQUEST_AIRPORTS'
export const RECEIVE_AIRPORTS = 'RECEIVE_AIRPORTS'

export const requestAirports = () => {
  return { type: REQUEST_AIRPORTS }
}

export const receiveAirports = data => {
  return {
    type: RECEIVE_AIRPORTS,
    data,
  }
}
